async function showReservedDateOnCalendar(location_id)   {
    let location_reservations = await getLocationReservations(location_id);
    console.log("location_reservations")
    console.log(location_reservations)
    let calendar_dates = $('#calendar_dates').find('.calendar_date');
    for(calendar_date of calendar_dates) {
        console.log($(calendar_date).attr('data-date'))
        // if (location_reservations.some(booking => booking.date === $(calendar_date).attr('data-date'))) {
        //     $(calendar_date).append('<div class="has_booking_star absolute text-red-400 dark:text-red-400 text-[8px] -top-[0px] right-[2px]"><i class="fa fa-asterisk"></i> </div>');
        //     console.log('MATCH')
        // } else {
        //     $(calendar_date).find('.has_booking_star').remove();
        // }
        if (location_reservations.some(booking => booking.date === $(calendar_date).attr('data-date'))) {
            $(calendar_date).append('<div class="has_booking_star absolute rotate-45 top-[-1px] right-[-6px] w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-green-400 dark:border-b-green-400/70"></div>\n');
        } else {
            $(calendar_date).find('.has_booking_star').remove();
        }
    }
    // console.log("calendar_dates")
    // console.log(calendar_dates)
}

window.showReservedDateOnCalendar = showReservedDateOnCalendar;
const getLocationReservations = async (location_id) => {
    try {
        const response = await fetch(`/api/reservations/all`, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body:    JSON.stringify({
                json:        true,
                location_id: location_id,
            })
        });
        return await response.json()
    } catch (error) {
        console.log(error)
    }
}

